import React from "react";

/**
 * BAT Ear echolocation mark — a bat silhouette suggested by a symmetric
 * row of soundwave bars. Wings rise from the center "ears/body".
 */
export function LogoMark({ size = 40, animated = true, className = "" }) {
  // Symmetric heights forming a bat-wing / soundwave silhouette (out of 60)
  const heights = [12, 26, 18, 40, 30, 54, 30, 40, 18, 26, 12];
  const barW = 3.2;
  const gap = 2.4;
  const totalW = heights.length * barW + (heights.length - 1) * gap;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${totalW} 60`}
      className={className}
      aria-hidden="true"
      role="img"
    >
      {heights.map((h, i) => {
        const x = i * (barW + gap);
        const isCenter = i === Math.floor(heights.length / 2);
        return (
          <rect
            key={i}
            x={x}
            y={60 - h}
            width={barW}
            height={h}
            rx={0.6}
            fill={isCenter ? "#F1D570" : "#D4AF37"}
            className={animated ? "wave-bar" : ""}
            style={
              animated
                ? { animationDelay: `${Math.abs(i - 5) * 0.09}s` }
                : undefined
            }
            opacity={isCenter ? 1 : 0.85}
          />
        );
      })}
    </svg>
  );
}

export function Logo({ dark = true, className = "", markSize = 40 }) {
  const src = dark ? "/logo-dark.png" : "/logo-light.png";
  return (
    <img
      src={src}
      alt="BAT Ear Research & Investigations"
      style={{ height: Math.round(markSize * 1.7), width: "auto" }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}

export default Logo;
